export default __webpack_public_path__ + "static/media/IMG_5233.cba5edc1.WEBP";